export const HOLIDAYS = [
  {
    label: "New Year's Day: January 1 (yearly)",
    key: 'NEW_YEAR',
  },
  {
    label: 'Memorial Day: Last Monday of May (yearly)',
    key: 'MEMORIAL_DAY',
  },
  {
    label: 'After Independence Day: July 5 (yearly)',
    key: 'INDEPENDENCE_DAY',
  },
  {
    label: 'Labor Day: First Monday of September (yearly)',
    key: 'LABOUR_DAY',
  },
  {
    label: 'Thanksgiving Day: Fourth Thursday of November (yearly)',
    key: 'THANKSGIVING',
  },
  {
    label: 'Christmas Day: December 25 (yearly)',
    key: 'CHRISTMAS',
  },
];
